module.exports = __webpack_public_path__ + "static/1984-5-f63a7f35fd7eb2bcbf1be95ea1738ebf.png";